import { render, staticRenderFns } from "./useTutorial.vue?vue&type=template&id=be2b9d82&scoped=true&"
import script from "./useTutorial.vue?vue&type=script&lang=js&"
export * from "./useTutorial.vue?vue&type=script&lang=js&"
import style0 from "./useTutorial.vue?vue&type=style&index=0&id=be2b9d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2b9d82",
  null
  
)

export default component.exports